namespace GeniuzPOS.CustomReport {
    export class ReportCusSaleComparisonYearColumns {
        static columnsKey = 'CustomReport.ReportCusSaleComparison';
    }
}
